import { render, staticRenderFns } from "./CategorySlidebar.vue?vue&type=template&id=721146ac"
import script from "./CategorySlidebar.vue?vue&type=script&lang=js"
export * from "./CategorySlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports